import { ColoursObj, Typography } from '@eventr/common-storybook'
import { MarkdownRow } from '../../../home/components/summary/markdownRow'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { ColouredIcon } from './colouredIcon'
import { RowInfo } from './rowInfo'
import { CardText } from './cardText'

interface IRowInfoNotesProps {
    notes: string
    type?: 'card' | 'page'
}
export const RowInfoNotes = ({ notes, type }: IRowInfoNotesProps) => {
    if (!notes) return null
    if (type === 'page') {
        return (
            <RowInfo
                start={
                    <ColouredIcon
                        name={'Edit_Text'}
                        iconColour={ColoursObj.coreBrights.secondary}
                    />
                }
                under={MarkdownRow({ value: notes })}
                middle={
                    <Typography variant="bodyBold">
                        {cardTranslation('Notes')}
                    </Typography>
                }
            />
        )
    }
    return (
        <RowInfo
            start={
                <ColouredIcon
                    name={'Free_Edit'}
                    bubble
                    bubbleColour={ColoursObj.coreBrights.secondary}
                />
            }
            middle={<CardText useMarkdown  >{notes}</CardText>}
        />
    )
}
